import { useQuery } from 'react-query'
import { UseQueryOptions } from 'react-query/types/react/types'
import axios, { AxiosError } from 'axios'

import * as urls from './urls'

import { AdminEvent, Event, Reporter } from '@/types'

export const useAdminEventQuery = (
  id: string,
  options?: Omit<
    UseQueryOptions<AdminEvent, AxiosError, AdminEvent>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery<AdminEvent, AxiosError, AdminEvent>(
    ['admin_event', id],
    () => axios.get(urls.adminEvent(id)).then(r => r.data),
    { ...options },
  )

export const useAvailableReportersQuery = (event: Event) =>
  useQuery<{ reporter: Reporter; available: boolean }[]>(
    ['available_reporters', event.id],
    () => axios.get(event.available_reporters_url).then(r => r.data),
  )
